var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-designer',{ref:"formDesigner",attrs:{"queryId":_vm.routeQueryId},model:{value:(_vm.form.fdForm),callback:function ($$v) {_vm.$set(_vm.form, "fdForm", $$v)},expression:"form.fdForm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }